(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   pages - user - USER ACCOUNT PAGE
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   delete account modal
 *   helper functions
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {
		if(isUserAccountPage()) {

			/* delete account */
			/* ************** */

			setupDeleteAccountBlock();

		}
	});




/** --------------------------------------------------
    #delete account modal
    -------------------------------------------------- */

	function setupDeleteAccountBlock() {

		const MODAL_ACTIVE_CLASS = 'js-deleteaccountmodal-shown';

		$(document).on('click', '.delete-my-account', function(e) {
			e.preventDefault();
			$('html').addClass(MODAL_ACTIVE_CLASS);
		});

		$(document).on('click', '.cancel-delete', function(e) {
			e.preventDefault();
			if($('html').hasClass(MODAL_ACTIVE_CLASS)) {
				$('html').removeClass(MODAL_ACTIVE_CLASS);
			}
		});

		$(document).on('click', '.close-delete', function(e) {
			e.preventDefault();
			if($('html').hasClass(MODAL_ACTIVE_CLASS)) {
				$('html').removeClass(MODAL_ACTIVE_CLASS);
			}
		});

		$(document).on('keydown.accountdelete', function(event) {
			if(event.keyCode === 27) {
				if($('html').hasClass(MODAL_ACTIVE_CLASS)) {
					$('html').removeClass(MODAL_ACTIVE_CLASS);
				}
			}
		});

	} /* setupDeleteAccountBlock */




/** --------------------------------------------------
    #helper functions
    -------------------------------------------------- */

	function isUserAccountPage() {
		let isUserPage = false;

		if($('body').hasClass('path-user')) {
			isUserPage = true;
		}

		return isUserPage;
	} /* isUserAccountPage */
	
	
	
})(jQuery);
